import LText from "@components/LText";
import { RichText } from "@libs/shared-ui/native";
import Accordion from "../common/Accordion";

const Paragraph = ({ children }: { children: React.ReactNode }) => (
  <LText variant="bodyM2" color="white">
    {children}
  </LText>
);

const Info = ({ text }: { text: string | null }) => {
  if (!text) return null;
  return (
    <Accordion title="Entry info" initialOpen={true}>
      <RichText markdown={text} Paragraph={Paragraph} />
    </Accordion>
  );
};

export default Info;
